// extracted by mini-css-extract-plugin
export var label = "_6c-1";
export var reminder = "_6c-0";